import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import Models from "@/pages/Models";
import VehicleDetail from "@/pages/VehicleDetail";
import TestDrive from "@/pages/TestDrive";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Gallery from "@/pages/Gallery";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AuthCallback from "@/pages/admin/AuthCallback";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import VehiclesAdmin from "@/pages/admin/VehiclesAdmin";
import VehicleEditor from "@/pages/admin/VehicleEditor";
import LeadsAdmin from "@/pages/admin/LeadsAdmin";
import GalleryAdmin from "@/pages/admin/GalleryAdmin";
import MediaLibrary from "@/pages/admin/MediaLibrary";
import OffersAdmin from "@/pages/admin/OffersAdmin";
import Offers from "@/pages/Offers";
import SettingsAdmin from "@/pages/admin/SettingsAdmin";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/models" element={<Models />} />
        <Route path="/offers" element={<Offers />} />
        <Route path="/models/:slug" element={<VehicleDetail />} />
        <Route path="/test-drive" element={<TestDrive />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="vehicles" element={<VehiclesAdmin />} />
        <Route path="vehicles/new" element={<VehicleEditor />} />
        <Route path="vehicles/:id" element={<VehicleEditor />} />
        <Route path="leads" element={<LeadsAdmin />} />
        <Route path="gallery" element={<GalleryAdmin />} />
        <Route path="media" element={<MediaLibrary />} />
        <Route path="offers" element={<OffersAdmin />} />
        <Route path="settings" element={<SettingsAdmin />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="bottom-right" richColors closeButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
